/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";

export default class AppActions extends BaseCom {

    localGoBack = () => {
        if(this.props.onBack)
            this.props.onBack();
        else
            this.goBack();
    }

    render() {
        return <div className="app-actions">
            {!this.props.noBack && <div>
                <button
                    type="button"
                    className="btn btn-secondary btn-lg"
                    onClick={this.localGoBack}>Go Back</button>
            </div>}
            <div className="flex-fill text-end">
                {this.props.children}
            </div>
        </div>
    }
}